// The import card in the platform agent's panel (D12): before a menu import or a copy runs, while it runs, and how it
// ended. Wording from the Amigo for menus design's copy sheet (Import card, Not live yet, Buttons, Importing, Failed,
// What to try, the 5 reasons, Went live, Import done).
export default {
  title: {
    import: 'Importeer het menu van {{platform}}',
    copy: 'Kopieer het menu van {{restaurant}}',
    data: 'Maak het menu dat Amigo las',
  },
  // A menu Amigo read from a file or the chat (QA36): a change card with each dish, before it is created.
  contents: {
    title: '{{categories}} en {{dishes}} aanmaken',
    from: {
      file: 'Amigo heeft dit uit je bestand gelezen',
      chat: 'Amigo heeft dit uit onze chat gelezen',
    },
    summary: 'Maakt {{categories}} en {{dishes}} aan. Controleer hieronder in de lijst elk gerecht met zijn prijs.',
    price: 'Prijs',
    tax_category: 'Belastingcategorie',
    no_price: 'Nog geen prijs',
    default_tax: 'Je standaardtarief',
    // Once approved: the import's run, in the words of creating a menu.
    creating: '{{categories}} en {{dishes}} worden aangemaakt…',
    done: 'Het menu is aangemaakt: {{categories}}, {{dishes}} en {{option_groups}} staan op het menu van {{restaurant}}',
    done_plain: 'Het menu is aangemaakt',
  },
  waiting: 'Wacht op goedkeuring',
  labels: {
    from: 'Van',
    to: 'Naar',
    menu: 'Menu',
    brings_over: 'Neemt over',
  },
  from: {
    // "Lieferando · lieferando.de/speisekarte/pizzeria-lupo-koeln"
    platform: '{{platform}} · {{link}}',
    // "Pizzeria Lupo · 12 categories, 140 dishes"
    restaurant: '{{restaurant}} · {{categories}}, {{dishes}}',
    // "The menu Amigo read · 2 categories, 4 dishes" (B19)
    data: 'Het menu dat Amigo las · {{categories}}, {{dishes}}',
  },
  to: {
    only_location: '{{name}}, de enige locatie',
    brand_one: 'Merkmenu van {{name}}, de enige locatie',
    brand_other: 'Merkmenu van {{name}}, alle {{count}} locaties',
  },
  menu: {
    empty: 'Leeg, dus dit wordt het menu',
    adds: 'Wordt toegevoegd aan het huidige menu ({{size}}). Gerechten met dezelfde naam worden bijgewerkt; er wordt niets verwijderd.',
    // The menu's name and size: "Speisekarte: 12 categories, 140 dishes".
    size_named: '{{name}}: {{categories}}, {{dishes}}',
    size: '{{categories}}, {{dishes}}',
  },
  counts: {
    categories_one: '{{count}} categorie',
    categories_other: '{{count}} categorieën',
    dishes_one: '{{count}} gerecht',
    dishes_other: '{{count}} gerechten',
    option_groups_one: '{{count}} optiegroep',
    option_groups_other: '{{count}} optiegroepen',
  },
  // What an import brings over, as one list: "Categories, dishes, prices, option groups, photos, and allergens and
  // nutrition where Lieferando has them". Each item starts lowercase; the list's first letter is capitalised.
  brings_over: {
    everything: 'Alles, zoals het is',
    categories: 'categorieën',
    dishes: 'gerechten',
    descriptions: 'beschrijvingen',
    prices: 'prijzen',
    option_groups: 'optiegroepen',
    photos: "foto's",
    where: {
      allergens_nutrition: 'allergenen en voedingswaarden waar {{platform}} die heeft',
      allergens: 'allergenen waar {{platform}} die heeft',
      nutrition: 'voedingswaarden waar {{platform}} die heeft',
    },
  },
  not_live: '{{restaurant}} is nog niet live: gasten kunnen het menu zien via de shoplink, maar niet bestellen.',
  buttons: {
    import: 'Importeren',
    copy: 'Kopiëren',
    cancel: 'Annuleren',
  },
  hint: 'Of reageer hieronder om iets te wijzigen.',
  action_failed: 'Dat is niet gelukt, dus er is niets gewijzigd. Probeer het zo opnieuw.',
  importing: {
    title: {
      import: 'Importeren van {{platform}}…',
      copy: 'Kopiëren van {{restaurant}}…',
    },
    started: 'Gestart om {{time}}',
    queued: 'Starten…',
    hint: 'Dit kan een paar minuten duren. Je kunt het paneel sluiten of doorwerken; ik post het resultaat hier.',
  },
  done: {
    // What is on the menu now, while the card is the only result ({{categories}} … are `counts`): "The import from
    // Lieferando is done: 12 categories, 140 dishes and 38 option groups are on Pizzeria Lupo's menu".
    title: {
      import:
        'De import van {{platform}} is voltooid: {{categories}}, {{dishes}} en {{option_groups}} staan op het menu van {{restaurant}}',
      copy: 'Het kopiëren is voltooid: {{categories}}, {{dishes}} en {{option_groups}} staan op het menu',
    },
    // Without counts, or once Amigo's result under the card says them.
    title_plain: {
      import: 'De import van {{platform}} is klaar',
      copy: 'De kopie is klaar',
    },
    finished: 'Voltooid om {{time}}',
    // The page in the sidebar's words: "Open Menu → Manage menus".
    open: 'Open {{page}}',
  },
  failed: {
    title: {
      import: 'Importeren mislukt: {{reason}}',
      copy: 'Kopiëren mislukt: {{reason}}',
    },
    title_plain: {
      import: 'Importeren mislukt',
      copy: 'Kopiëren mislukt',
    },
    nothing: {
      import: 'Er is niets geïmporteerd.',
      copy: 'Er is niets gekopieerd.',
    },
    what_to_try: 'Wat je kunt proberen:',
    retry: 'Opnieuw proberen',
    reasons: {
      listing_not_found: {
        title: 'vermelding niet gevonden',
        text: '{{platform}} heeft geen restaurant op deze link. Er is niets geïmporteerd.',
        try: 'Open de link in een browser om te controleren of het menu van het restaurant wordt getoond en stuur hem daarna opnieuw.',
      },
      listing_not_supported: {
        title: 'vermelding niet ondersteund',
        text: 'Dit is een ketenpagina van {{platform}}, niet het menu van één restaurant, dus ik kan hem niet importeren. Er is niets geïmporteerd.',
        try: 'Stuur de link naar de eigen menupagina van het restaurant op {{platform}}.',
      },
      platform_failed: {
        title: '{{platform}} mislukt',
        text: '{{platform}} reageerde niet, dus er is niets geïmporteerd.',
        try: 'Probeer het over een paar minuten opnieuw.',
      },
      // A copy from another restaurant that failed on our side: there is no platform to name.
      copy_failed: {
        title: 'kopiëren mislukt',
        text: 'Het kopiëren is niet voltooid, dus er is niets gekopieerd.',
        try: 'Probeer het over een paar minuten opnieuw.',
      },
      // {{listing}} and {{currency}} are currencies with their sign: "British pounds (£)", "euros (€)". {{page}} is the
      // sidebar's My info.
      currency_mismatch: {
        title: 'de valuta komt niet overeen',
        text: 'De vermelding staat in {{listing}}, maar {{restaurant}} gebruikt {{currency}}. Er is niets geïmporteerd.',
        try: 'Stuur een vermelding in {{currency}}, of controleer eerst de valuta van het restaurant bij {{page}}.',
        text_other: 'De vermelding staat in een andere valuta dan die van {{restaurant}}. Er is niets geïmporteerd.',
        try_other: 'Stuur een vermelding in de valuta van het restaurant, of controleer eerst de valuta bij {{page}}.',
      },
      link_paused: {
        title: 'link gepauzeerd',
        text: 'Deze link is 3 keer achter elkaar mislukt, dus imports ervan zijn gepauzeerd tot {{time}}. Er is niets geïmporteerd.',
        text_no_until:
          'Deze link is 3 keer achter elkaar mislukt, dus imports ervan zijn voorlopig gepauzeerd. Er is niets geïmporteerd.',
        try: 'Stuur een link van een ander platform, of kopieer het menu van een ander restaurant.',
      },
    },
  },
  stopped: {
    title: 'Gestopt: {{restaurant}} is live gegaan',
    nothing: {
      import: 'Er is niets geïmporteerd',
      copy: 'Er is niets gekopieerd',
    },
  },
  // The card folded to one line.
  line: {
    cancelled: 'Geannuleerd',
    expired: 'Verlopen',
    replaced: 'Vervangen',
  },
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Goedgekeurd.',
    cancelled: 'Geannuleerd.',
    retried: 'Opnieuw geprobeerd.',
  },
};
